var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext } from 'react';
var NextFormItemDeepContext = createContext({});
var NextFormItemShallowContext = createContext({});
export var FormItemDeepProvider = function (_a) {
    var children = _a.children, prefixCls = _a.prefixCls, labelAlign = _a.labelAlign, labelCol = _a.labelCol, inline = _a.inline, wrapperCol = _a.wrapperCol, size = _a.size;
    return (React.createElement(NextFormItemDeepContext.Provider, { value: {
            prefixCls: prefixCls,
            labelAlign: labelAlign,
            labelCol: labelCol,
            wrapperCol: wrapperCol,
            inline: inline,
            size: size
        } }, children));
};
FormItemDeepProvider.displayName = 'FormItemDeepProvider';
export var useDeepFormItem = function () {
    return useContext(NextFormItemDeepContext);
};
export var FormItemShallowProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(NextFormItemShallowContext.Provider, { value: props }, children));
};
export var useShallowFormItem = function () {
    return useContext(NextFormItemShallowContext);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/context.js
// module id = 243
// module chunks = 0